import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import { DownOutlined, ExclamationCircleOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { ICourseDefinition, listCourseDefinitions, createCourseDefinition, updateCourseDefinition, deleteCourseDefinition, pageCourseDefinitions } from '../../service/api/courseDefinition';
import moment from 'moment';
import { IRolePermission, listPermissions } from '../../service/api/account';
import { FormInstance } from 'antd/lib/form/Form';
const { confirm } = Modal;
const { Option } = Select;

interface IPermissionListProps {
  visible: boolean
  setVisible: (visible: boolean) => void;
}
const PermissionList: React.FC<IPermissionListProps> = ({
  visible,
  setVisible,
}) => {
  const [permissions, setPermissions] = useState<IRolePermission[]>();
  const [permissionDetail, setPermissionDetail] = useState<IRolePermission>();
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [courseDefinitions, setCourseDefinitions] = useState<ICourseDefinition[]>();
  const formRef = React.createRef<FormInstance>();
  const columns = [
    {
      title: '权限名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '权限编码',
      dataIndex: 'code',
      key: 'code',
    },
    // {
    //   title: '状态',
    //   dataIndex: 'enable',
    //   key: 'enable',
    //   render: (text: any, record: any) => {
    //     if (record.enable) {
    //       return <span style={{color:'green'}}>使用中</span>
    //     } else {
    //       return <span style={{color:'grey'}}>已停用</span>
    //     }
    //   }
    // },
    // {
    //   title: '操作',
    //   key: 'action',
    //   // render: (text: any, record: any) => {
    //   //   if (record.enable) {
    //   //     return <Space size="middle">
    //   //       <a onClick={() => {
    //   //         // console.log("record:" + JSON.stringify(record));
    //   //         setPermissionDetail(record);
    //   //         setVisible(true);
    //   //       }}>编辑 </a>
    //   //       <a onClick={e => { onEnable(e, record) }}>停用 </a>
    //   //     </Space>
    //   //   } else {
    //   //     return <Space size="middle">
    //   //       <a onClick={() => {
    //   //         // console.log("record:" + JSON.stringify(record));
    //   //         setPermissionDetail(record);
    //   //         setVisible(true);
    //   //       }}>编辑 </a>
    //   //       <a onClick={e => { onEnable(e, record) }}>启用 </a>
    //   //     </Space>
    //   //   }
    //   // },
    // }
  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize]);

  useEffect(() => {
    if (permissionDetail) {
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        formRef.current!.setFieldsValue(permissionDetail);
      }, 100);
    }
  }, [permissionDetail]);

  const loadData = () => {
    listPermissions().then((info: any) => {
      setPermissions(info?.data);
      // console.log("info:" + JSON.stringify(info.data));
    });
    listCourseDefinitions().then((info: any) => {
      setCourseDefinitions(info?.data);
    });
  }

  // const onFinish = (values: any) => {
  //   // console.log("values:" + JSON.stringify(values));
  //   if (permissionDetail) {
  //     updatePermission({
  //       ...values,
  //       id: permissionDetail.id
  //     }).then((info: any) => {
  //       // console.log("info:" + JSON.stringify(info));
  //       message.success("更新成功");
  //       onClose();
  //       loadData();
  //     });
  //   } else {
  //     createPermission(values).then((info: any) => {
  //       // console.log("info:" + JSON.stringify(info));
  //       message.success("创建成功");
  //       onClose();
  //       loadData();
  //     });
  //   }
  // };

  // const onEnable = (e: any, item: IRolePermission) => {
  //   e.stopPropagation();
  //   confirm({
  //     title: '提示',
  //     icon: <ExclamationCircleOutlined />,
  //     content: item.enable?'确定要停用该权限吗？停用后无法被选到':'确定要启用该权限吗？',
  //     okText: '确定',
  //     okType: 'danger',
  //     cancelText: '取消',
  //     onOk() {
  //       enablePermission(item.id, !item.enable).then((info: any) => {
  //         // console.log("info:" + JSON.stringify(info));
  //         message.success("操作成功");
  //         loadData();
  //       });
  //     },
  //     onCancel() {
  //     },
  //   });
  // }

  const onClose = () => {
    setPermissionDetail(undefined);
    setVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  const onPageChange = (pageNum: number, pageSize?: number) => {
    setPageNum(pageNum);
    setPageSize(pageSize || 10);
    // setPageSize(info.data.pageSize);
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 20 },
    },
  };

  // 下拉框值
  const options = courseDefinitions?.map((courseDefinition) =>
    <Option key={courseDefinition.id} value={courseDefinition.id}>{courseDefinition.name}</Option>);



  return (
    <Card bordered={false}>
      <Table dataSource={permissions} columns={columns} pagination={false} />
      <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
      </div>
      {/* <Drawer
        title={permissionDetail ? "编辑权限" : "新增权限"}
        visible={visible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="名称"
                rules={[{ required: true, message: '请输入名称' }]}
              >
                <Input placeholder="请输入名称" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="remark"
                label="备注"
                rules={[{ required: false, message: '请输入备注' }]}
              >
                <Input placeholder="请输入备注" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="effectiveDay"
                label="权限有效天数"
                rules={[{ required: true, message: '请输入权限有效天数' }]}
              >
                <Input placeholder="请输入名称" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="sellPrice"
                label="售卖价格"
                rules={[{ required: true, message: '请输入售卖价格' }]}
              >
                <Input placeholder="请输入售卖价格" />
              </Form.Item>
            </Col>
          </Row>
          <Form.List name="courseDefinitionRefs">
            {(fields, { add, remove }) => (
              <>
                <div style={{ paddingBottom: '10px' }}>包含课程信息</div>
                {fields.map(({ name, fieldKey, ...restField }) => (
                  <Row gutter={16}>
                    <Col span={10}>
                      <Form.Item
                        {...restField}
                        name={[name, 'value']}
                        fieldKey={[fieldKey, 'value']}
                        rules={[{ required: true, message: '请输入课程数' }]}
                      >
                        <Input placeholder="请输入课程数" />
                      </Form.Item>
                    </Col>
                    <Col span={10}>
                      <Form.Item
                        {...restField}
                        name={[name, 'courseDefinitionId']}
                        fieldKey={[fieldKey, 'courseDefinitionId']}
                        rules={[{ required: true, message: '请选择课程' }]}
                      >
                        <Select placeholder="请选择课程"  >
                          {options}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <MinusCircleOutlined onClick={() => remove(name)} style={{ paddingTop: '8px' }} />
                    </Col>
                  </Row>

                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    添加课程信息
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" >保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer> */}
    </Card>
  );
};

export default PermissionList;
